var map = {
	"./CanvasClear": 38,
	"./CanvasClear.js": 38,
	"./CanvasMove": 39,
	"./CanvasMove.js": 39,
	"./CommandAbstract": 19,
	"./CommandAbstract.js": 19,
	"./ComponentDelete": 40,
	"./ComponentDelete.js": 40,
	"./ComponentDrag": 41,
	"./ComponentDrag.js": 41,
	"./ComponentEnter": 42,
	"./ComponentEnter.js": 42,
	"./ComponentExit": 43,
	"./ComponentExit.js": 43,
	"./ComponentNext": 44,
	"./ComponentNext.js": 44,
	"./ComponentPrev": 45,
	"./ComponentPrev.js": 45,
	"./ComponentStyleClear": 46,
	"./ComponentStyleClear.js": 46,
	"./CopyComponent": 47,
	"./CopyComponent.js": 47,
	"./DeleteComponent": 48,
	"./DeleteComponent.js": 48,
	"./ExportTemplate": 49,
	"./ExportTemplate.js": 49,
	"./Fullscreen": 50,
	"./Fullscreen.js": 50,
	"./MoveComponent": 51,
	"./MoveComponent.js": 51,
	"./OpenAssets": 52,
	"./OpenAssets.js": 52,
	"./OpenBlocks": 53,
	"./OpenBlocks.js": 53,
	"./OpenLayers": 54,
	"./OpenLayers.js": 54,
	"./OpenStyleManager": 55,
	"./OpenStyleManager.js": 55,
	"./OpenTraitManager": 56,
	"./OpenTraitManager.js": 56,
	"./PasteComponent": 57,
	"./PasteComponent.js": 57,
	"./Preview": 58,
	"./Preview.js": 58,
	"./Resize": 59,
	"./Resize.js": 59,
	"./SelectComponent": 12,
	"./SelectComponent.js": 12,
	"./SelectPosition": 24,
	"./SelectPosition.js": 24,
	"./ShowOffset": 60,
	"./ShowOffset.js": 60,
	"./SwitchVisibility": 61,
	"./SwitchVisibility.js": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;